import React, { useState } from "react";
import "styles/humanResources.css";

async function descargarArchivo(url) {
  const nombreArchivo = url.substring(url.lastIndexOf("/") + 1);

  const response = await fetch(url);

  if (!response.ok) {
    throw new Error("Error al descargar el archivo");
  }

  const blob = await response.blob();

  const blobUrl = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = blobUrl;
  link.setAttribute("download", nombreArchivo);

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  window.URL.revokeObjectURL(blobUrl);
}

const HumanResources = () => {
  const [downloadingFile, setDownloadingFile] = useState(null);

  const handleDescargar = async (url) => {
    try {
      setDownloadingFile(url);
      await descargarArchivo(url);
    } catch (error) {
      console.error("Error al descargar el archivo:", error);
      alert("No fue posible descargar el archivo");
    } finally {
      setDownloadingFile(null);
    }
  };

  const documentos = [
    {
      titulo: "AUTORIZACIÓN DE LICENCIA POR LUTO",
      url: "https://storage.elitevacances.com/uploads/intranet/EV-TH-FO-058_V2_Licencia_por_Luto.pdf",
    },
    {
      titulo: "SOLICITUD DE LICENCIA",
      url: "https://storage.elitevacances.com/uploads/intranet/EV-TH-FO-057_V2_Solicitud_de_Licencia-4.pdf",
    },
  ];

  return (
    <section className="container-page">
      <h1 className="title-section-promotions text-center">
        Documentos recursos humanos
      </h1>

      <div className="app container m-2">
        <div className="pdf-container">
          {documentos.map((documento) => (
            <div
              key={documento.url}
              className="pdf-card"
              onClick={() =>
                downloadingFile !== documento.url &&
                handleDescargar(documento.url)
              }
              style={{
                cursor:
                  downloadingFile === documento.url ? "not-allowed" : "pointer",
                opacity: downloadingFile === documento.url ? 0.7 : 1,
              }}
            >
              <img
                src="https://cdn-icons-png.flaticon.com/512/4726/4726010.png"
                alt=""
                width={"50%"}
              />
              <p>{documento.titulo}</p>

              {/* <button
                type="button"
                disabled={downloadingFile === documento.url}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDescargar(documento.url);
                }}
              >
                {downloadingFile === documento.url
                  ? "Descargando..."
                  : "Descargar PDF"}
              </button> */}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HumanResources;
